import { prefixObjectValues as pre } from '../utils';

const prefix = 'medical-license-table';

const table = pre(
  {
    row: 'row-',
    filterSelect: 'med-license-filter-select',
    sortLicenseType: 'sort-type',
    sortNum: 'sort-num',
    sortLocation: 'sort-location',
    sortStatus: 'sort-status',
    sortExpiration: 'sort-expiration',
    licenseType: 'license-type-',
    number: 'license-number-',
    location: 'license-location-',
    statusPill: 'license-statusPill-',
    statusRow: 'license-statusRow-',
    expiration: 'license-expiration-',
    editBtn: 'edit-btn',
    deleteBtn: 'delete-btn',
    addBtn: 'add-btn',
    prevPageBtn: 'prev-btn',
    nextPageBtn: 'next-btn',
    numOfPage: 'num-btn-',
    statusFilter: 'filter-status',
    locationFilter: 'filter-location',
    expirationFilter: 'filter-expiration',
    emptyState: 'empty-state',
  },
  prefix
);

export default {
  ...table,
};
